import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Logger from "./components/Logger";
import {configure} from "mobx";
import { Provider } from 'mobx-react';
import UserStore from "./stores/UserStore";
import Confirm from "./components/confirm/Confirm";
import Alert from "./components/alert/Alert";
import Notify from "./components/notify/Notify";
import RbcAPI from "./apis/RbcAPI";
import AccountStore from "./stores/AccountStore";
import Progress from "./components/Progress";
import Calculator from "./components/calculator/Calculator";
import TaxEstimator from "./components/tax/TaxEstimator";
import ModelStore from "./stores/ModelStore";
import AuthAPI from "./apis/AuthAPI";
import TermsOfUse from "./components/page/TermsOfUse";
import PrivacyPolicy from "./components/page/PrivacyPolicy";
import BillingAPI from "./apis/BillingAPI";
import ConvertKitAPI from "./apis/ConvertKitAPI";
import config from "react-global-configuration";
import Tracking from "./components/Tracking";
import TrackingAPI from "./apis/TrackingAPI";

Logger.init()

const trackingId = config.get("google.trackingId")
if (trackingId && trackingId !== "" && trackingId !== "NONE") {
  Tracking.initialize(trackingId, config.get("google.options"))
}

// Migrating from MobX 5 to 6, turning off @action enforcement for now.
// In the future, we'll want to turn on computedRequiresReaction, reactionRequiresObservable and observableRequiresReaction and enforceActions: "observed".
// See docs here: https://mobx.js.org/migrating-from-4-or-5.html
configure({ enforceActions: "never" });

const authAPI = new AuthAPI()
const rbcAPI = new RbcAPI()
const billingAPI = new BillingAPI()
const convertKitAPI = new ConvertKitAPI()
const trackingAPI = new TrackingAPI()

const userStore = new UserStore({
  rbcAPI,
  billingAPI,
  convertKitAPI
})

const taxEstimator = new TaxEstimator()

const calculator = new Calculator({
  taxEstimator
})

const accountStore = new AccountStore({
  rbcAPI
})

const modelStore = new ModelStore({
  rbcAPI, calculator, userStore
})

const resources = {
  confirm: new Confirm(),
  notify: new Notify(),
  alert: new Alert(),
  authAPI,
  rbcAPI,
  billingAPI,
  convertKitAPI,
  trackingAPI,
  userStore,
  accountStore,
  modelStore,
  calculator,
  taxEstimator,
  progress: new Progress(),
  privacyPolicy: new PrivacyPolicy(),
  termsOfUse: new TermsOfUse(),
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider {...resources}>
    <App />
  </Provider>
);

// Register service worker using Create React App's built-in functionality
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.register();

// render(<Provider {...resources}>
//        <App />
//      </Provider>, document.getElementById('root'))

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
